import { arcadiaLate2021Theme } from '@perch-labs/shrike';

export const HELP_WIDGET_ID = 'ze-snippet';
export const HELP_WIDGET_SCRIPT_URL =
  'https://static.zdassets.com/ekr/snippet.js?key=8d8c058c-05a1-4ab0-b7bc-5aceee833e01';
export const helpWidgetSettings = () => {
  (window as any).zESettings = {
    webWidget: {
      color: {
        theme: arcadiaLate2021Theme.colors.content.primary,
      },
      offset: {
        horizontal: '0px',
        mobile: {
          vertical: '64px',
        },
        vertical: '80px',
      },
      position: { horizontal: 'right', vertical: 'top' },
    },
  };
};
export const hideHelpWidget = () => (window as any)?.zE?.('webWidget', 'hide');
export const showHelpWidget = () => (window as any)?.zE?.('webWidget', 'show');
